// @flow
import { batch } from 'react-redux';
//import { IconVideo, IconVideoOff } from '../../icons';
import {
    IconToolbarCameraEmpty,
    IconToolbarCameraEmptyDisabled,
} from "../../icons";

import AbstractButton from "./AbstractButton";
import type { Props } from "./AbstractButton";



/**
 * An abstract implementation of a button for toggling video mute.
 */
export default class AbstractVideoMuteButton<
    P: Props,   
    S: *
> extends AbstractButton<P, S> {
    icon = IconToolbarCameraEmpty;
    toggledIcon = IconToolbarCameraEmptyDisabled;


    buttonLabel = 'toolbar.buttonLabel.videomute';
    accessibilityLabel = 'toolbar.accessibilityLabel.videomute';
    label = 'toolbar.videomute';
    tooltip = 'toolbar.videomute';
    /**
     * Handles clicking / pressing the button, and toggles the video mute state
     * accordingly.
     *
     * @protected
     * @returns {void}
     */
    _handleClick() {
    // Below two lines are added extra in oder to play sound when VideoMute Button clicked
       const audio = new Audio('./sounds/video-mute.wav');
       audio.volume = 0.2;
       audio.play();
       this._setVideoMuted(!this._isVideoMuted());
       this.buttonLabel = this._isVideoMuted() ? 'toolbar.buttonLabel.videomute' : 'toolbar.buttonLabel.videounmute';
       this.accessibilityLabel = this._isVideoMuted() ? 'toolbar.accessibilityLabel.videounmuted' : 'toolbar.accessibilityLabel.videomuted';  
   }
    

    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this._isVideoMuted();
    }

    /**
     * Helper function to be implemented by subclasses, which must return a
     * {@code boolean} value indicating if video is muted or not.
     *
     * @protected
     * @returns {boolean}
     */
    _isVideoMuted() {
       
        // To be implemented by subclass.
    }

    /**
     * Helper function to perform the actual setting of the video mute / unmute
     * action.
     *
     * @param {boolean} videoMuted - Whether video should be muted or not.
     * @protected
     * @returns {void}
     */
    _setVideoMuted(videoMuted: boolean) {
       
        // eslint-disable-line no-unused-vars
        // To be implemented by subclass.
    }
}
